var map = {
	"./br.json": "33d0",
	"./de.json": "6ce2",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./it.json": "0825",
	"./nl.json": "a625",
	"./uk.json": "62ea",
	"./us.json": "115b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";